import db from './dexieConfig'

const paginationKeys = {
  libraryAds: 'libraryKey',
  teamLibraryAds: 'teamLibraryKey'
}

export async function checkAndCacheAll (table, fetchFunction) {
  try {
    // Check for cached pagination key
    const paginationKey = paginationKeys[table]
    let lastKey = null
    if (paginationKey) {
      const keyRecord = await db.paginationKeys.get(paginationKey)
      lastKey = keyRecord?.lastKey
  }

    // Check if any values exist in Dexie DB
    const cachedValues = await db[table].orderBy('insertOrder').toArray()
    const cleanedCachedValues = cachedValues.map(({ insertOrder, ...rest }) => rest)

    if (cachedValues && cachedValues.length > 0) {
      // console.log('Using cached values:', cleanedCachedValues)
      // Fetch fresh data in background and update cache
      const fetchPromise = fetchFunction()
        .then(returnedResults => {
          const results = returnedResults.results ? returnedResults.results : returnedResults
          // Add insertOrder field to each item
          const itemsWithOrder = results.map((item, index) => ({
            ...item,
            insertOrder: Date.now() + index // Using timestamp + index to ensure unique ordering
          }))

          db[table].clear()
          db[table].bulkPut(itemsWithOrder)

          // Check for a next key. Pass it into the next key table if it exists
          if (returnedResults.nextPage) {
            const paginationKey = paginationKeys[table] || null

            if (!paginationKey) {
              console.error('No pagination key found for table:', table)
              return results
            }

            db.paginationKeys.put({ id: paginationKey, lastKey: returnedResults.nextPage })
          }

          return results
        })
        .catch(error => {
          console.error('Error fetching fresh data:', error)
          return cleanedCachedValues // Fall back to cached values if fetch fails
        })

      return {
        cached: cleanedCachedValues,
        fresh: fetchPromise,
        lastKey
      }
    }

    // If no cached values, fetch all documents
    const fetchPromise = fetchFunction()
      .then(returnedResults => {
        const results = returnedResults.results ? returnedResults.results : returnedResults
        // Add insertOrder field to each item
        const itemsWithOrder = results.map((item, index) => ({
          ...item,
          insertOrder: Date.now() + index // Using timestamp + index to ensure unique ordering
        }))
        db[table].bulkPut(itemsWithOrder)

        // Add pagination key update
        if (returnedResults.nextPage) {
          const paginationKey = paginationKeys[table] || null

          if (!paginationKey) {
            console.error('No pagination key found for table:', table)
            return results
          }

          db.paginationKeys.put({ id: paginationKey, lastKey: returnedResults.nextPage })
        }

        return results // Original results don't have insertOrder
      })

    return {
      cached: [],
      fresh: fetchPromise,
      lastKey
    }
  } catch (error) {
    console.error('Error in checkAndCacheAll:', error)
    // If there's an error checking cache, fall back to fetch function
    const fetchPromise = fetchFunction()
    return {
      cached: [],
      fresh: fetchPromise,
      lastKey: null
    }
  }
}

export async function wipeDB () {
  await Promise.all([
    db.boards.clear(),
    db.briefs.clear(),
    db.folders.clear(),
    db.libraryAds.clear(),
    db.paginationKeys.clear(),
    db.spyderAnalytics.clear(),
    db.spyders.clear(),
    db.teamLibraryAds.clear()
  ])
}
